export default __webpack_public_path__ + "static/media/calendar.7285df24.svg";